import { useState } from 'react';
import { btn, text } from '../ui';

// Reorder the weekly CLR rotation. The top of the list is on call this week; the
// rest follow in order and repeat. Saving anchors week 0 to this Monday, so the
// rotation stays put even if the schedule's Start date changes.
export default function ClrEditor({ clrRoster = [], thisWeek, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(clrRoster);

  const start = () => {
    setDraft(clrRoster);
    setEditing(true);
  };
  const move = (i, delta) => {
    const j = i + delta;
    if (j < 0 || j >= draft.length) return;
    const next = [...draft];
    [next[i], next[j]] = [next[j], next[i]];
    setDraft(next);
  };
  const save = () => {
    onSave(draft);
    setEditing(false);
  };

  const rows = editing ? draft : clrRoster;

  return (
    <div className="mb-6 border rounded p-4">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-lg font-semibold">CLR rotation order</h2>
        {editing ? (
          <div className="flex gap-2">
            <button onClick={save} className={btn.save}>Save</button>
            <button onClick={() => setEditing(false)} className={btn.cancel}>Cancel</button>
          </div>
        ) : (
          <button onClick={start} className={btn.primary}>Edit order</button>
        )}
      </div>
      <p className={text.hint}>
        Top of the list is on call the week of {thisWeek}, then down the list, repeating.
        Membership is set in the Settings team table; this only changes the order.
      </p>

      {rows.length === 0 ? (
        <p className="text-sm text-gray-500 mt-2">No one is in the CLR rotation yet.</p>
      ) : (
        <ol className="mt-3 space-y-1">
          {rows.map((name, i) => (
            <li key={`${name}-${i}`} className="flex items-center gap-2 text-sm">
              <span className="w-6 text-right text-gray-400">{i + 1}.</span>
              <span className={`flex-1 ${i === 0 ? 'font-medium' : ''}`}>
                {name}{i === 0 && <span className="text-xs text-green-700 ml-2">this week</span>}
              </span>
              {editing && (
                <span className="flex gap-1">
                  <button
                    onClick={() => move(i, -1)}
                    disabled={i === 0}
                    className={btn.link}
                    title="Move up"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => move(i, 1)}
                    disabled={i === draft.length - 1}
                    className={btn.link}
                    title="Move down"
                  >
                    ↓
                  </button>
                </span>
              )}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
